//import { General } from './../entities/dossier';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GenericService } from '../generic.service';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { AuthService } from '../auth.service';
import { DossierService } from '../dossier.service';
import { Dossier, Experience, Realisation, Skill, Dc, General, Fe, Adm, Actions, Eval, Connaissances, Langue, Adresse, Diplome, Remarques, Certif, Collaborateur, Mission } from '../entities/dossier';
import {Tag} from '../entities/tag';
import * as _ from 'underscore';
import * as loadDash from "lodash";
import {  FileUploader, FileSelectDirective } from 'ng2-file-upload/ng2-file-upload';
import { saveAs } from 'file-saver';
// import { PdfReaderService } from '../pdf-reader.service';
import * as pdfjsLib from 'pdfjs-dist';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-dossier-competences',
  templateUrl: './dossier-competences.component.html',
  styleUrls: ['./dossier-competences.component.css']
})
export class DossierCompetencesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dossier-competences/dossier-competences.component.ts